import { OmneaError } from '@omnea-digital/toolbox'
import isNil from 'lodash/isNil'

type ApiErrorType = {
  type: string
  detail: object
}
const isApiErrorType = (error: any): error is ApiErrorType => error && typeof error.type === 'string'

// Assertion functions need to be "function" not arrow functions
export function throwIfApiError<T extends ApiErrorType>(error: T | Error | undefined | null): asserts error is undefined {
  if (isNil(error)) return
  if (isApiErrorType(error)) throw new ApiError(error)
  throw error
}

export class ApiError<T extends ApiErrorType> extends OmneaError<T['type'], T['detail']> {
  type: T['type']

  constructor(error: T) {
    super(error)
    this.type = error.type
  }
}
